import { DropdownOption } from '../../../models/dropdown-option';
import { PartnerAccount } from '@tmx/data-access';
import { map, pipe } from 'rxjs';

export function toDropdownOptions() {
  return pipe(
    map<
      { partnerAccounts: PartnerAccount[]; customerAccounts: PartnerAccount[] },
      { partnerAccounts: DropdownOption[]; customerAccounts: DropdownOption[] }
    >(({ partnerAccounts, customerAccounts }) => {
      return {
        partnerAccounts: partnerAccounts.map(
          (account) => new DropdownOption(account.name, account.alias)
        ),
        customerAccounts: customerAccounts.map(
          (account) => new DropdownOption(account.name, account.alias)
        ),
      };
    })
  );
}
